<div
  #dialogContainer
  class="iu-info-dialog-background"
  [ngStyle]="{ display: isOpen ? 'block' : 'none' }"
  (click)="onBackdropClick()"></div>
<p-toast position="center" [baseZIndex]="baseZIndex" [key]="key">
  <ng-template let-message pTemplate="message">
    <!-- one alert dialog: title and message announced, focus kept on its buttons -->
    <div
      class="info-dialog-panel"
      role="alertdialog"
      aria-modal="true"
      [attr.aria-labelledby]="key + '-title'"
      [attr.aria-describedby]="key + '-detail'">
      <div class="info-dialog-content">
        @if (dialogType === 'confirm' || dialogType === 'confirmyesno') {
          <i aria-hidden="true" class="fa fa-exclamation-triangle fa-3x"></i>
        } @else if (dialogType === 'info') {
          <i aria-hidden="true" class="fa fa-info-circle fa-3x"></i>
        } @else if (dialogType === 'error') {
          <i aria-hidden="true" class="fa fa-times-circle fa-3x"></i>
        }
        <h3 [id]="key + '-title'">{{ message.summary }}</h3>
        <p [id]="key + '-detail'" [innerHTML]="message.detail"></p>
      </div>
      <div class="info-dialog-buttons apiz-p-grid ui-fluid">
        @switch (dialogType) {
          @case ('confirm') {
            <div class="p-col-6">
              <button
                class="p-button-secondary"
                data-cy="info-dialog-cancel-btn"
                pButton
                type="button"
                [attr.data-cy-type]="dialogType"
                label="{{ cancelLabel ?? ('infodialog.cancel' | translate) }}"
                (click)="cancelDialog()"></button>
            </div>
            <div class="p-col-6">
              <button
                #confirm
                class="p-button p-button-primary"
                [class.info-dialog-btn-danger]="danger"
                data-cy="info-dialog-confirm-btn"
                pButton
                type="button"
                [attr.data-cy-type]="dialogType"
                label="{{ confirmLabel ?? ('infodialog.ok' | translate) }}"
                (click)="confirmDialog()"></button>
            </div>
          }
          @case ('confirmyesno') {
            @if (stayLabel) {
              <div class="p-col-4">
                <button
                  class="p-button-text"
                  data-cy="info-dialog-stay-btn"
                  pButton
                  type="button"
                  label="{{ stayLabel }}"
                  (click)="dismissDialog()"></button>
              </div>
            }
            <div [class]="stayLabel ? 'p-col-4' : 'p-col-6'">
              <button
                class="p-button-secondary"
                data-cy="info-dialog-cancel-btn"
                pButton
                type="button"
                [attr.data-cy-type]="dialogType"
                label="{{ cancelLabel ?? ('infodialog.no' | translate) }}"
                (click)="cancelDialog()"></button>
            </div>
            <div [class]="stayLabel ? 'p-col-4' : 'p-col-6'">
              <button
                #confirmYesNo
                class="p-button p-button-primary"
                [class.info-dialog-btn-danger]="danger"
                data-cy="info-dialog-confirm-btn"
                pButton
                type="button"
                [attr.data-cy-type]="dialogType"
                label="{{ confirmLabel ?? ('infodialog.yes' | translate) }}"
                (click)="confirmDialog()"></button>
            </div>
          }
        }

        @if (dialogType !== 'confirm' && dialogType !== 'confirmyesno') {
          <div class="p-col-12">
            <button
              #confirmOK
              class="p-button p-button-primary"
              data-cy="info-dialog-OK-btn"
              pButton
              type="button"
              [attr.data-cy-type]="dialogType"
              label="{{ 'infodialog.ok' | translate }}"
              (click)="confirmDialog()"></button>
          </div>
        }
      </div>
    </div>
  </ng-template>
</p-toast>
